import { render, staticRenderFns } from "./FontosHirIcon.vue?vue&type=template&id=35217bc6&"
import script from "./FontosHirIcon.vue?vue&type=script&lang=js&"
export * from "./FontosHirIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports